/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementDropdownListIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementDropdownListIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M11 5.29293L13.1464 3.14648L13.8535 3.85359L11 6.70714L8.14641 3.85359L8.85352 3.14648L11 5.29293Z"
              fill="currentColor"
            />
            <path d="M14 10H2V9H14V10Z" fill="currentColor" />
            <path d="M2 13H14V12H2V13Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementDropdownListIcon.tags = [
  'dropdown',
  'dropdown list',
  'menu',
  'arrow',
  'select',
  'expand',
  'options',
];

ElementDropdownListIcon.category = 'Navigator';

ElementDropdownListIcon.iconSize = 16;
